<ul class="timeperiod" *ngIf="exchangeOffer">
  <li><p>Trade Start<span class="value">{{tradeStartDate|date:'MM/dd/yyyy'}}</span><span class="days"></span></p></li>
  <li><p>Trade End<span class="value">{{tradeEndDate|date:'MM/dd/yyyy'}}</span><span class="days"></span></p></li>
</ul>
<div class="row">
  <div class="row10">
    <div [ngClass]="{'show':chartDataReesponse?.length > 0,'hide':chartDataReesponse?.length == 0}" class="col-md-12">
      <div class="ct" id="divchart"></div>
    </div>
    <div *ngIf="chartDataReesponse?.length === 0" class="nodata">
      <i class="fa fa-exclamation-triangle icon"></i>
      <p>No Data Available</p>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-lg-10 col-md-10 col-sm-12 col-xs-12">
    <ul class="steps" *ngIf="chartDataReesponse?.length > 0">
      <li><span>LOI</span>Offer Negotiation</li>
      <li><span>PSA</span>PSA Negotiation</li>
      <li><span>DD</span>Due Diligence</li>
      <li><span>HC</span>Hard Contract
    </ul>
  </div>
  <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
    <button style="float:right" class="btn btn-success btn-lg" (click)="openModal(EditPhase,'panlestyle');">Edit Timeline</button>
  </div>
</div>

<ng-template #EditPhase class="pull-left">

  <div class="modal-header">
    <h4 class="modal-title pull-left">Edit Timeline</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="onEditPhaseCancel();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="EditPhaseForm" autocomplete="off">
      <div class="form-group border-div">
        <div class="row">
          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <label class="form-label">
              Offer Negotiation
            </label>
          </div>
          <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 text-right">
            <a *ngIf="AllowLOIEdit" class="blueone" href="javascript:void(0);" (click)="EditPhaseDate(1);" tooltip="Edit"><i aria-hidden="true" class="icofont icofont-ui-edit icon"></i></a>
          </div>
        </div>
        <div role="group" class="textbox-date">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="textbox-date d-flex">
                <input bsDatepicker formControlName="Add_loiStartDate" [(ngModel)]="PhaseInputModel.LOIStartDate" (ngModelChange)="onChange(1)" required class="form-control d-flex" type="text" [attr.disabled]="AllowLOIEdit ? '' : null">
                <i class="icofont icofont-ui-calendar icon d-flex"></i>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="textbox-date d-flex">
                <input bsDatepicker formControlName="Add_loiEndDate" [(ngModel)]="PhaseInputModel.LOIEndDate" (ngModelChange)="onChange(1)" class="form-control" type="text" [attr.disabled]="AllowLOIEdit ? '' : null">
                <i class="icofont icofont-ui-calendar icon"></i>
              </div>
            </div>
          </div>
          <div *ngIf="(Add_loiStartDate.invalid && isEditPhaseFormSubmitted )||(Add_loiStartDate.invalid && (Add_loiStartDate.dirty || Add_loiStartDate.touched))">
            <p class="redtext">
              Invalid LOI Start Date
            </p>
          </div>
        </div>
        <div role="group" class="textbox-date">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <label class="form-label" style="margin-top:10px">
                LOI Start Date
              </label>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <label class="form-label" style="margin-top:10px">
                LOI End Date
              </label>
            </div>
            <div *ngIf="(Add_loiEndDate.invalid && isEditPhaseFormSubmitted )||(Add_loiEndDate.invalid && (Add_loiEndDate.dirty || Add_loiEndDate.touched))">
              <p class="redtext">
                Invalid LOI End Date
              </p>
            </div>
          </div>
        </div>
        <!--<div role="group">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <label class="custom-checkbox">
                <input type="checkbox" formControlName="Phase_IsLOICompleted" [attr.disabled]="AllowLOIEdit ? '' : null" (change)="onPhaseCompleted(1);" [(ngModel)]="PhaseInputModel.IsLOICompleted">
                Completed
                <i></i>
              </label>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="textbox-date" *ngIf="PhaseInputModel.IsLOICompleted">
                <input bsDatepicker formControlName="LOIPhase_Completed" [(ngModel)]="PhaseInputModel.LOICompletedDate" class="form-control" type="text" [attr.disabled]="AllowLOIEdit ? '' : null">
                <i class="icofont icofont-ui-calendar icon"></i>
                <div *ngIf="isLOIPhaseCompletedDateInvalid">
                  <p class="redtext">
                    Completed Date is required
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>-->
        <!--<div role="group" class="textbox-date">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" *ngIf="PhaseInputModel.IsLOICompleted">
              <label class="form-label" style="margin-top:10px">
                LOI Completed Date
              </label>
            </div>
          </div>
        </div>-->
        <div role="group" class="textbox-date">
          <div class="text-right margin-top-15">
            <button *ngIf="!AllowLOIEdit" class="btn btn-default btn-lg" (click)="CancelPhaseDate(1);">Cancel</button>
            <button *ngIf="!AllowLOIEdit" class="btn btn-border btn-lg" [disabled]="disableSavebtn" (click)="openSaveModal(templateDateEditConfirmation,'deletemodal',1, false)">Update</button>
            <button *ngIf="!AllowLOIEdit" class="btn btn-success btn-lg" [disabled]="disableSavebtn" (click)="openSaveModal(templateDateEditConfirmation,'deletemodal',1, true)">Update All</button>
          </div>
        </div>
      </div>
      <div class="form-group border-div">
        <div class="row">
          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <label class="form-label">
              PSA Negotiation
            </label>
          </div>
          <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 text-right">
            <a *ngIf="AllowPSAEdit" class="blueone" href="javascript:void(0);" (click)="EditPhaseDate(2);" tooltip="Edit"><i aria-hidden="true" class="icofont icofont-ui-edit icon"></i></a>
          </div>
        </div>
        <div role="group" class="textbox-date">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="textbox-date d-flex">
                <input bsDatepicker formControlName="Add_psaStartDate" [(ngModel)]="PhaseInputModel.PSAStartDate" (ngModelChange)="onChange(2)" required class="form-control" type="text" [attr.disabled]="AllowPSAEdit ? '' : null">
                <i class="icofont icofont-ui-calendar icon"></i>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="textbox-date d-flex">
                <input bsDatepicker formControlName="Add_psaEndDate" [(ngModel)]="PhaseInputModel.PSAEndDate" (ngModelChange)="onChange(2)" class="form-control" type="text" [attr.disabled]="AllowPSAEdit ? '' : null">
                <i class="icofont icofont-ui-calendar icon"></i>
              </div>
            </div>
            <div *ngIf="(Add_psaStartDate.invalid && isEditPhaseFormSubmitted )||(Add_psaStartDate.invalid && (Add_psaStartDate.dirty || Add_psaStartDate.touched))">
              <p class="redtext">
                Invalid PSA Start Date
              </p>
            </div>
          </div>
          <div role="group" class="textbox-date">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <label class="form-label" style="margin-top:10px">
                  PSA Start Date
                </label>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <label class="form-label" style="margin-top:10px">
                  PSA End Date
                </label>
              </div>
              <div *ngIf="(Add_psaEndDate.invalid && isEditPhaseFormSubmitted )||(Add_psaEndDate.invalid && (Add_psaEndDate.dirty || Add_psaEndDate.touched))">
                <p class="redtext">
                  Invalid PSA End Date
                </p>
              </div>
            </div>
          </div>
        </div>
        <!--<div role="group">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <label class="custom-checkbox">
                <input type="checkbox" formControlName="Phase_IsPSACompleted" [attr.disabled]="AllowPSAEdit ? '' : null" (change)="onPhaseCompleted(2);" [(ngModel)]="PhaseInputModel.IsPSACompleted">
                Completed
                <i></i>
              </label>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="textbox-date" *ngIf="PhaseInputModel.IsPSACompleted">
                <input bsDatepicker formControlName="PSAPhase_Completed" [(ngModel)]="PhaseInputModel.PSACompletedDate" class="form-control" type="text" [attr.disabled]="AllowPSAEdit ? '' : null">
                <i class="icofont icofont-ui-calendar icon"></i>
                <div *ngIf="isPSAPhaseCompletedDateInvalid">
                  <p class="redtext">
                    Completed Date is required
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div role="group" class="textbox-date">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" *ngIf="PhaseInputModel.IsPSACompleted">
              <label class="form-label" style="margin-top:10px">
                PSA Completed Date
              </label>
            </div>
          </div>
        </div>-->
        <div role="group" class="textbox-date">
          <div class="text-right margin-top-15">
            <button *ngIf="!AllowPSAEdit" class="btn btn-default btn-lg" (click)="CancelPhaseDate(2);">Cancel</button>
            <button *ngIf="!AllowPSAEdit" class="btn btn-border btn-lg" [disabled]="disableSavebtn" (click)="openSaveModal(templateDateEditConfirmation,'deletemodal',2, false)">Update</button>
            <button *ngIf="!AllowPSAEdit" class="btn btn-success btn-lg" [disabled]="disableSavebtn" (click)="openSaveModal(templateDateEditConfirmation,'deletemodal',2, true)">Update All</button>
          </div>
        </div>
        <div role="group" *ngIf="modifiedPSADate != null">
          <div class="d-flex chart-box-header align-item-center margin-bottom-20 div-no-prop-background">
            <h5 class="mr-auto margin-bottom-5 info-box">
              <i container="body" class="userpermissiontooltip margin-right-5" triggers="mouseenter:mouseleave" aria-hidden="true" placement="right">
                <img src="/assets/img/Frame.svg" class="info-icon-blue-position">
              </i>
              <span><b>Update All </b>will change <b style="font-weight:bold">PSA Negotiation </b>Start and End date to <b style="font-weight:bold">{{modifiedPSADate}}</b></span>
            </h5>
          </div>
        </div>
      </div>
      <div class="form-group border-div">
        <div class="row">
          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <label class="form-label">
              Due Diligence
            </label>
          </div>
          <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 text-right">
            <a *ngIf="AllowDDEdit" class="blueone" href="javascript:void(0);" (click)="EditPhaseDate(3);" tooltip="Edit"><i aria-hidden="true" class="icofont icofont-ui-edit icon"></i></a>
          </div>
        </div>
        <div role="group" class="textbox-date">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="textbox-date d-flex">
                <input bsDatepicker formControlName="Add_ddStartDate" [(ngModel)]="PhaseInputModel.DDStartDate" (ngModelChange)="onChange(3)" required class="form-control" type="text" [attr.disabled]="AllowDDEdit ? '' : null">
                <i class="icofont icofont-ui-calendar icon"></i>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="textbox-date d-flex">
                <input bsDatepicker formControlName="Add_ddEndDate" [(ngModel)]="PhaseInputModel.DDEndDate" (ngModelChange)="onChange(3)" class="form-control" type="text" [attr.disabled]="AllowDDEdit ? '' : null">
                <i class="icofont icofont-ui-calendar icon"></i>
              </div>
            </div>
            <div *ngIf="(Add_ddStartDate.invalid && isEditPhaseFormSubmitted )||(Add_ddStartDate.invalid && (Add_ddStartDate.dirty || Add_ddStartDate.touched))">
              <p class="redtext">
                Invalid DD Start Date
              </p>
            </div>
          </div>
          <div role="group" class="textbox-date">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <label class="form-label" style="margin-top:10px">
                  DD Start Date
                </label>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <label class="form-label" style="margin-top:10px">
                  DD End Date
                </label>
              </div>
              <div *ngIf="(Add_ddEndDate.invalid && isEditPhaseFormSubmitted )||(Add_ddEndDate.invalid && (Add_ddEndDate.dirty || Add_ddEndDate.touched))">
                <p class="redtext">
                  Invalid DD End Date
                </p>
              </div>
            </div>
          </div>
        </div>
        <!--<div role="group">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <label class="custom-checkbox">
                <input type="checkbox" formControlName="Phase_IsDDCompleted" [attr.disabled]="AllowDDEdit ? '' : null" (change)="onPhaseCompleted(3);" [(ngModel)]="PhaseInputModel.IsDDCompleted">
                Completed
                <i></i>
              </label>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="textbox-date" *ngIf="PhaseInputModel.IsDDCompleted">
                <input bsDatepicker formControlName="DDPhase_Completed" [(ngModel)]="PhaseInputModel.DDCompletedDate" class="form-control" type="text" [attr.disabled]="AllowDDEdit ? '' : null">
                <i class="icofont icofont-ui-calendar icon"></i>
                <div *ngIf="isDDPhaseCompletedDateInvalid">
                  <p class="redtext">
                    Completed Date is required
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div role="group" class="textbox-date">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" *ngIf="PhaseInputModel.IsDDCompleted">
              <label class="form-label" style="margin-top:10px">
                DD Completed Date
              </label>
            </div>
          </div>
        </div>-->
        <div role="group" class="textbox-date">
          <div class="text-right margin-top-15">
            <button *ngIf="!AllowDDEdit" class="btn btn-default btn-lg" (click)="CancelPhaseDate(3);">Cancel</button>
            <button *ngIf="!AllowDDEdit" class="btn btn-border btn-lg" [disabled]="disableSavebtn" (click)="openSaveModal(templateDateEditConfirmation,'deletemodal',3, false)">Update</button>
            <button *ngIf="!AllowDDEdit" class="btn btn-success btn-lg" [disabled]="disableSavebtn" (click)="openSaveModal(templateDateEditConfirmation,'deletemodal',3, true)">Update All</button>
          </div>
        </div>
        <div role="group" *ngIf="modifiedDDDate != null">
          <div class="d-flex chart-box-header align-item-center margin-bottom-20 div-no-prop-background">
            <h5 class="mr-auto margin-bottom-5 info-box">
              <i container="body" class="userpermissiontooltip margin-right-5" triggers="mouseenter:mouseleave" aria-hidden="true" placement="right">
                <img src="/assets/img/Frame.svg" class="info-icon-blue-position">
              </i>
              <span><b style="font-weight:bold">Update All </b>will change <b style="font-weight:bold">Due Diligence </b>Start and End date to <b style="font-weight:bold">{{modifiedDDDate}}</b></span>
            </h5>
          </div>
        </div>
      </div>
      <div class="form-group border-div">
        <div class="row">
          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <label class="form-label">
              Hard Contract
            </label>
          </div>
          <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 text-right">
            <a *ngIf="AllowHCEdit" class="blueone" href="javascript:void(0);" (click)="EditPhaseDate(4);" tooltip="Edit"><i aria-hidden="true" class="icofont icofont-ui-edit icon"></i></a>
          </div>
        </div>
        <div role="group" class="textbox-date">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="textbox-date d-flex">
                <input bsDatepicker formControlName="Add_hcStartDate" [(ngModel)]="PhaseInputModel.HCStartDate" required class="form-control" type="text" [attr.disabled]="AllowHCEdit ? '' : null">
                <i class="icofont icofont-ui-calendar icon"></i>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="textbox-date d-flex">
                <input bsDatepicker formControlName="Add_hcEndDate" [(ngModel)]="PhaseInputModel.HCEndDate" class="form-control" type="text" [attr.disabled]="AllowHCEdit ? '' : null">
                <i class="icofont icofont-ui-calendar icon"></i>
              </div>
            </div>
            <div *ngIf="(Add_hcStartDate.invalid && isEditPhaseFormSubmitted )||(Add_hcStartDate.invalid && (Add_hcStartDate.dirty || Add_hcStartDate.touched))">
              <p class="redtext">
                Invalid HC Start Date
              </p>
            </div>
          </div>
          <div role="group" class="textbox-date">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <label class="form-label" style="margin-top:10px">
                  HC Start Date
                </label>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <label class="form-label" style="margin-top:10px">
                  HC End Date
                </label>
              </div>
              <div *ngIf="(Add_hcEndDate.invalid && isEditPhaseFormSubmitted )||(Add_hcEndDate.invalid && (Add_hcEndDate.dirty || Add_hcEndDate.touched))">
                <p class="redtext">
                  Invalid HC End Date
                </p>
              </div>
            </div>
          </div>
          <!--<div role="group">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <label class="custom-checkbox">
                  <input type="checkbox" formControlName="Phase_IsHCCompleted" [attr.disabled]="AllowHCEdit ? '' : null" (change)="onPhaseCompleted(3);" [(ngModel)]="PhaseInputModel.IsHCCompleted">
                  Completed
                  <i></i>
                </label>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="textbox-date" *ngIf="PhaseInputModel.IsHCCompleted">
                  <input bsDatepicker formControlName="HCPhase_Completed" [(ngModel)]="PhaseInputModel.HCCompletedDate" class="form-control" type="text" [attr.disabled]="AllowHCEdit ? '' : null">
                  <i class="icofont icofont-ui-calendar icon"></i>
                  <div *ngIf="isHCPhaseCompletedDateInvalid">
                    <p class="redtext">
                      Completed Date is required
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div role="group" class="textbox-date">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" *ngIf="PhaseInputModel.IsHCCompleted">
                <label class="form-label" style="margin-top:10px">
                  HC Completed Date
                </label>
              </div>
            </div>
          </div>-->
          <div role="group" class="textbox-date">
            <div class="text-right">
              <button *ngIf="!AllowHCEdit" class="btn btn-default btn-lg" (click)="CancelPhaseDate(4);">Cancel</button>
              <button *ngIf="!AllowHCEdit" class="btn btn-border btn-lg" [disabled]="disableSavebtn" (click)="openSaveModal(templateDateEditConfirmation,'deletemodal',4, false)">Update</button>
              <button *ngIf="!AllowHCEdit" class="btn btn-success btn-lg" [disabled]="disableSavebtn" (click)="openSaveModal(templateDateEditConfirmation,'deletemodal',4, true)">Update All</button>
            </div>
          </div>
          <div role="group" *ngIf="modifiedHCDate != null">
            <div class="d-flex chart-box-header align-item-center margin-bottom-20 div-no-prop-background">
              <h5 class="mr-auto margin-bottom-5 info-box">
                <i container="body" class="userpermissiontooltip margin-right-5" triggers="mouseenter:mouseleave" aria-hidden="true" placement="right">
                  <img src="/assets/img/Frame.svg" class="info-icon-blue-position">
                </i>
                <span><b style="font-weight:bold">Update All </b>will change <b style="font-weight:bold">Hard Contract </b>Start and End date to <b style="font-weight:bold">{{modifiedHCDate}}</b></span>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

</ng-template>

<ng-template #templateDateEditConfirmation>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Task</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefConfirmation.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">Would you like to update all subsequent tasks?</h6>
    </div>
    <div class="text-right margin-top-15">
      <button class="btn btn-lg btn-default margin-right-5" (click)="modalRefPhaseDateConfirmation.hide()">Cancel</button>
      <button class="btn btn-border btn-lg margin-right-5" (click)="UpdatePhaseDate(false)">Update Selected</button>
      <button class="btn btn-success btn-lg" (click)="UpdatePhaseDate(true)">Update All</button>
    </div>
  </div>
</ng-template>
